import { render, staticRenderFns } from "./ProxyVoteModal.vue?vue&type=template&id=5ceb3522&scoped=true&"
import script from "./ProxyVoteModal.vue?vue&type=script&lang=ts&"
export * from "./ProxyVoteModal.vue?vue&type=script&lang=ts&"
import style0 from "./ProxyVoteModal.vue?vue&type=style&index=0&id=5ceb3522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ceb3522",
  null
  
)

export default component.exports